@use '../../scss/utility';
@use './video-utility' as innerUtility;
@use './controls/controls';
@use './player/player';
@use './video-vars';
@forward '~plyr/src/sass/plyr.scss';

:host {
  @include video-vars.wb-video-vars;

  display: block;
  position: relative;

  @include utility.breakpoint-from('mq4') {
    @include video-vars.wb-video-desktop-vars;
  }
}

// PLYR OVERRIDES

.plyr {
  .plyr--youtube {
    .plyr__poster {
      pointer-events: none; // fixes problem with non-clickable youtube elements
    }
    &.plyr--paused .plyr__poster {
      display: none;
    }
  }

  /* stylelint-disable-next-line */
  .plyr__progress__buffer {
    color: var(--video-progress-buffer-color);
  }

  &__tooltip {
    display: none;
  }

  .plyr__controls {
    padding: var(--video-controls-padding);
  }

  .plyr__control {
    margin: unset;
    &:hover {
      background: none;
    }
    &:focus-visible {
      border-radius: unset;
      outline-offset: unset;
      @include innerUtility.plyr-focus-visible;
    }
  }

  input[type='range'] {
    &:focus-visible {
      &::-webkit-slider-runnable-track {
        @include innerUtility.plyr-focus-visible;
      }

      &::-moz-range-track {
        @include innerUtility.plyr-focus-visible;
      }

      &::-ms-track {
        @include innerUtility.plyr-focus-visible;
      }
    }
  }

  .plyr__time:before {
    margin-inline-end: var(--controls-timer-text-gap);
  }

  .plyr__volume {
    input[type='range'] {
      margin: unset;
      padding-inline-end: utility.wb-pixel-to-rem(16px);
    }
  }

  .plyr__progress,
  .plyr__volume {
    input[type='range'] {
      height: unset;
      padding-block: var(--video-range-block-padding);
    }
  }

  .plyr__captions {
    @include utility.wb-text(
      'm',
      (
        responsive: false,
      )
    );
  }

  input[type='range'] {
    &::-webkit-slider-thumb {
      background-color: var(--video-range-indicator-color);
    }

    &::-moz-range-thumb {
      background-color: var(--video-range-indicator-color);
    }

    &::-ms-thumb {
      background-color: var(--video-range-indicator-color);
    }
  }
}

:host(:not([poster])) {
  .darken {
    .plyr__poster {
      background-color: var(--video-overlay-color);
    }
  }
}
